import { render, staticRenderFns } from "./Gender.vue?vue&type=template&id=24d2a14a"
import script from "./Gender.vue?vue&type=script&lang=ts"
export * from "./Gender.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports